import React, { FC, ReactNode } from "react";
import Alert, { AlertProps } from "../../../../shared/ui/feedback/Alert";
import Box from "../../../../shared/ui/display/Box";
import Button from "../../../../shared/ui/display/Button";
import CircularProgress from "../../../../shared/ui/feedback/CircularProgress";
import Grid from "../../../../shared/ui/display/Grid";
import TextField from "../../../../shared/ui/forms/TextField";
import Typography from "../../../../shared/ui/display/Typography";
import { CodeFieldProps } from "./types";
import useTranslations from "./useTranslations";

export type AuthConfirmUserFormProps = {
  phoneNumber: string;
  codeFieldProps: CodeFieldProps;
  handleResend: () => void | Promise<void>;
  handleSubmit: () => void | Promise<void>;
  alert?: {
    props: AlertProps;
    children: ReactNode | string;
  };
  isResendDisabled?: boolean;
  isSubmitDisabled?: boolean;
  isSubmitLoading?: boolean;
};

const AuthConfirmUserForm: FC<AuthConfirmUserFormProps> = ({
  phoneNumber,
  codeFieldProps,
  handleResend,
  handleSubmit,
  alert,
  isResendDisabled,
  isSubmitDisabled,
  isSubmitLoading,
}) => {
  const { btnSubmit, btnResendCode, helperCodeSent } = useTranslations({
    phoneNumber,
  });

  return (
    <Grid container direction="column" wrap="nowrap" spacing={3}>
      <Grid item>
        <Typography variant="body2">{helperCodeSent}</Typography>
      </Grid>
      {alert && (
        <Grid item mb={6}>
          <Alert {...alert.props}>{alert.children}</Alert>
        </Grid>
      )}
      <Grid item>
        <TextField
          {...codeFieldProps}
          fullWidth
          onKeyDown={(e) => {
            if (e.key === "Enter" && !isSubmitDisabled) handleSubmit();
          }}
        />
      </Grid>
      <Grid item>
        <Button
          onClick={handleSubmit}
          disabled={isSubmitDisabled}
          fullWidth
          variant="contained"
          size="large"
          startIcon={isSubmitLoading ? <CircularProgress size={20} /> : null}
        >
          {btnSubmit}
        </Button>
        <Box mt={3} textAlign="center">
          <Typography
            variant="body2"
            sx={{ cursor: isResendDisabled ? "default" : "pointer" }}
            color={isResendDisabled ? "grey.500" : "primary.main"}
            onClick={isResendDisabled ? undefined : handleResend}
          >
            {btnResendCode}
          </Typography>
        </Box>
      </Grid>
    </Grid>
  );
};

export default AuthConfirmUserForm;
